<template>
  <div @click="clickHandler">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ClickAssistant",
  props: {
    doubleClickDelay: {
      type: Number,
      default: 300
    },
    callback: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      clickTimes: 0,
      timeout: {},
      hasCallbackClick: false,
      hasCallbackDoubleClick: false,
    }
  },
  mounted() {
    this.hasCallbackClick = this.callback != null
        && this.callback.hasOwnProperty('click')
        && this.callback.click instanceof Function;
    this.hasCallbackDoubleClick = this.callback != null
        && this.callback.hasOwnProperty('dbClick')
        && this.callback.dbClick instanceof Function;
  },
  methods: {
    clickHandler() {
      this.clickTimes++;
      if (this.clickTimes === 2) {
        clearTimeout(this.timeout);
        if (this.hasCallbackClick) {
          this.callback.dbClick();
        } else {
          this.$emit('doubleClick');
        }
        this.clickTimes = 0;
      }
      let _this = this;
      this.timeout = setTimeout(() => {
        if (_this.clickTimes === 1) {
          if (_this.hasCallbackDoubleClick) {
            _this.callback.click();
          } else {
            _this.$emit('onceClick');
          }
          _this.clickTimes = 0;
        }
      }, this.doubleClickDelay);
    }
  }
}
</script>

<style scoped>

</style>